var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediaPushIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9240_994)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#27272C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1519 44.9517L45.3142 63.2501C44.585 64.3875 43.5299 65 42.4461 65C42.0089 65 41.5666 64.9003 41.1412 64.6955C39.5797 63.9466 38.8234 62.034 39.3451 60.1459L41.3775 51.001H34.9121C33.0889 51.001 31.4278 49.9634 30.5736 48.294C29.7194 46.6246 29.8258 44.614 30.8488 43.0514L41.6831 24.7495C42.7078 23.1536 44.3723 22.5919 45.8578 23.3041C47.4193 24.053 48.1756 25.9656 47.6539 27.8537L45.6198 37.0003L52.0903 37.0056C53.9118 37.0056 55.5729 38.0432 56.4271 39.7126C57.2796 41.3802 57.1749 43.3908 56.1519 44.9535V44.9517Z",
    fill: "#D6D6D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1519 44.9517L45.3142 63.2501C44.585 64.3875 43.5299 65 42.4461 65C42.0089 65 41.5666 64.9003 41.1412 64.6955C39.5797 63.9466 38.8234 62.034 39.3451 60.1459L41.3775 51.001H34.9121C33.0889 51.001 31.4278 49.9634 30.5736 48.294C29.7194 46.6246 29.8258 44.614 30.8488 43.0514L41.6831 24.7495C42.7078 23.1536 44.3723 22.5919 45.8578 23.3041C47.4193 24.053 48.1756 25.9656 47.6539 27.8537L45.6198 37.0003L52.0903 37.0056C53.9118 37.0056 55.5729 38.0432 56.4271 39.7126C57.2796 41.3802 57.1749 43.3908 56.1519 44.9535V44.9517Z",
    fill: "#D6D6D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9240_994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaPushIcon);
export default __webpack_public_path__ + "static/media/media-push-icon.6b2b6fb6747f5f1b454c1c33a5f261ac.svg";
export { ForwardRef as ReactComponent };